import { useMutation, useQueryClient } from "@tanstack/react-query";

import salesApiService from "app/pages/sales-intelligence/services/salesApiService";

import type { Playbook } from "../types/playbooks.types";

import { playbooksQueryKeys } from "./queryKeyFactory";

export const useDeletePlaybookMutation = () => {
    const queryClient = useQueryClient();

    return useMutation<void, Error, number>({
        mutationFn: (playbookId) => salesApiService.playbooks.deletePlaybook(playbookId),
        onSuccess: (_data, playbookId) => {
            queryClient.setQueryData<Playbook[]>(playbooksQueryKeys.all(), (playbooks) =>
                playbooks?.filter((playbook) => playbook.playbookId !== playbookId),
            );
        },
    });
};
